import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative mx-auto flex text-xs h-9 max-w-[var(--site-max-width)] items-center justify-between" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "flex items-center gap-4" }
const _hoisted_5 = {
  type: "button",
  class: "btn-bare inline-flex items-center gap-1 text-inherit hover:underline",
  "aria-label": "Change country and language"
}
const _hoisted_6 = {
  key: 0,
  class: "inline-flex h-[14px] w-[14px] shrink-0 overflow-hidden rounded-full"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["href"]

import { computed } from 'vue';
import { HelpCircle, ChevronDown } from 'lucide-vue-next';

import useContext from '@/composables/useContext';
import useCountrySwitcher from '@/composables/useCountrySwitcher';
import useGiftCard from '@/composables/useGiftCard';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

import Logout from '@/components/header/Logout.vue';
import LocaleSelector from '@/components/LocaleSelector.vue';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopHeader',
  props: {
    inverted: { type: Boolean }
  },
  setup(__props: any) {



const { channel, header } = useContext();
const { activeGiftCard } = useGiftCard();
const { availableCountries } = useCountrySwitcher();
const { websiteText } = useWebsiteTexts();

const hasActiveGiftCard = computed(() => (activeGiftCard.value?.giftCards?.length ?? 0) > 0);

const currentCountry = computed<any>(() => {
  const list = availableCountries.value as any[];
  if (!Array.isArray(list)) return null;
  // Match the country to the channel we're actually on (authoritative) rather
  // than the `current` flag, which can be stale right after a locale change.
  const channelSystemId = channel.value?.systemId;
  return (channelSystemId && list.find((c) => c.channelId === channelSystemId)) || list.find((c) => c.current) || list[0] || null;
});

const currentLanguage = computed(() => {
  const langs = currentCountry.value?.availableLanguages ?? [];
  return langs.find((l: any) => l.current) || langs[0] || null;
});

const countryDisplayName = computed(() => {
  const c = currentCountry.value;
  const fromChannel = channel.value?.displayName;
  const fromCountry = c?.displayName || c?.channelName || c?.id;
  const raw = fromCountry || fromChannel || '';
  return raw === '001' ? 'EU' : raw;
});

const languageDisplayName = computed(() => currentLanguage.value?.name || currentLanguage.value?.languageId || '');

const flagSrc = computed(() => {
  const id = currentCountry.value?.id;
  if (!id) return '';
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
    return require(`@/static/flags/${id.toLowerCase()}.svg`);
  } catch {
    return '';
  }
});

const topNavigationLink = computed(() => header.value?.topNavigatonLink);

const redeemUrl = computed(() => channel.value?.rootPath || '/');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hidden px-4 w-full tablet-up:block", _ctx.inverted ? 'absolute inset-x-0 top-0 z-40 bg-transparent text-background' : 'bg-topbar text-topbar-foreground'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (topNavigationLink.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: topNavigationLink.value.url,
              class: "flex items-center gap-1 visited:text-inherit text-inherit hover:text-inherit no-underline hover:underline"
            }, [
              _createVNode(_unref(HelpCircle), { class: "h-[14px] w-[14px]" }),
              _createElementVNode("span", null, _toDisplayString(topNavigationLink.value.label), 1)
            ], 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Popover), null, {
          default: _withCtx(() => [
            _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_5, [
                  (flagSrc.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createElementVNode("img", {
                          src: flagSrc.value,
                          alt: countryDisplayName.value,
                          class: "h-full w-full object-cover"
                        }, null, 8, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(countryDisplayName.value), 1),
                    (languageDisplayName.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(", " + _toDisplayString(languageDisplayName.value), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_unref(ChevronDown), { class: "h-3 w-3" })
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(PopoverContent), {
              align: "end",
              "side-offset": 8,
              "collision-padding": 16,
              class: "z-[10000] w-80 border border-border bg-background p-5 text-foreground"
            }, {
              default: _withCtx(() => [
                _createVNode(LocaleSelector)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (hasActiveGiftCard.value)
          ? (_openBlock(), _createBlock(Logout, {
              key: 0,
              class: "cursor-pointer text-inherit hover:underline"
            }))
          : (!_ctx.inverted)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: redeemUrl.value,
                class: "text-inherit visited:text-inherit no-underline hover:underline"
              }, _toDisplayString(_unref(websiteText)('header__redeem_giftcard').value || 'Lös in gåvokort'), 9, _hoisted_8))
            : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})